import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useReveal } from "@/lib/useReveal";

const FAQS = [
  {
    q: "Este spray tan-ul sigur?",
    a: "Da. Nu implică expunerea la razele UV. Folosim formule profesionale, dermatologic testate, fără îngrediente agresive.",
  },
  {
    q: "Cât rezistă?",
    a: "Între 7 și 10 zile, în funcție de îngrijirea pielii. Hidratarea zilnică prelungește durata bronzului.",
  },
  {
    q: "Aspectul va fi portocaliu?",
    a: "Nu. Folosim produse profesionale premium Norvell și Sjolie care oferă nuanțe naturale, adaptate tipului tău de piele.",
  },
  {
    q: "Cum mă pregătesc înainte de programare?",
    a: "Exfoliază pielea cu 24 de ore înainte și evită cremele, uleiurile, deodorantele sau parfumul în ziua programării.",
  },
  {
    q: "Ce se întâmplă după aplicarea spray tan-ului?",
    a: "Imediat după aplicare, bronzul conține un ghid de culoare care poate părea mai intens. După perioada recomandată de dezvoltare, pielea trebuie clătită conform instrucțiunilor primite. La spălare, excesul de culoare se îndepărtează, iar pe piele rămâne bronzul final: curat, uniform, natural și elegant.",
  },
  {
    q: "De ce bronzul pare mai închis imediat după aplicare?",
    a: "Imediat după aplicare se vede ghidul de culoare folosit pentru o distribuire uniformă a produsului. După clătire, excesul de pigment se îndepărtează, iar rezultatul final este un bronz natural, uniform și adaptat nuanței pielii.",
  },
  {
    q: "Pot alege modele cu stickere?",
    a: "Da, acesta este unul dintre serviciile noastre speciale — Sticker Glow Experience. Poți alege dintre mai multe modele creative.",
  },
];

export default function FAQ() {
  const r = useReveal();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-32 bg-[#F5E6D3]"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16">
        <div ref={r.ref} className={`max-w-2xl mb-12 ${r.className}`}>
          <div className="section-label mb-4">Întrebări frecvente</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
            Tot ce trebuie să <em className="italic text-[#B88746]">știi</em>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full bg-[#FFFDF9] rounded-2xl border border-[#D7B899]/40 px-4 sm:px-8"
          data-testid="faq-accordion"
        >
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#D7B899]/40 last:border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-serif text-lg sm:text-xl text-[#3B2A22] py-5 hover:no-underline hover:text-[#B88746]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#3B2A22]/75 text-base leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
